import { cn } from "@app/lib/utils";
import { HeroBgOverLayer, ScrollAnimationIcon } from "@assets/icons";
import { HeroSectionData } from "@modules/home/data/mockData";
import { trans } from "@mongez/localization";

interface HeroSectionProps {
  data: HeroSectionData;
  startAnimation?: boolean;
}

export function HeroSection({ data, startAnimation }: HeroSectionProps) {
  return (
    <div className="relative size-full h-screen max-h-lvh overflow-hidden">
      <HeroBgOverLayer backgrounds={data.backgrounds} />
      <div className="container z-10 size-full">
        <div className="flex h-full w-full flex-col justify-center">
          <div className="mb-5 h-[3px] w-[56px] animate-slide-up rounded-full bg-bright-orange max-lg:hidden" />

          <div className="relative z-10 min-w-max lg:animate-slide-down">
            <div
              className={cn(
                "overflow-hidden",
                startAnimation
                  ? "animation-delay-300 animate-expand-width"
                  : "",
              )}
            >
              <h1 className="mb-10 min-w-max text-[96px] font-semibold leading-[110px] max-lg:hidden">
                {trans("heroTitleLine1")}
                <br />
                {trans("heroTitleLine2")}
              </h1>
              <h1
                dir="ltr"
                className="mb-5 min-w-max text-4xl font-bold lg:hidden rtl:hidden"
              >
                PRIDE OF SAUDI <br /> MANUFACTURING
              </h1>
            </div>

            <div
              className={cn(
                "flex overflow-hidden rtl:max-lg:justify-end",
                startAnimation
                  ? "animation-delay-300 animate-expand-width max-lg:animate-expand-width-rtl"
                  : "",
              )}
            >
              <p className="min-w-max text-2xl font-light max-lg:hidden">
                {trans("heroDescriptionLine1")} {trans("heroDescriptionLine2")}
              </p>
              <h1
                dir="rtl"
                className="min-w-max font-ibm-plex-arabic text-4xl font-bold lg:hidden ltr:hidden rtl:me-auto"
              >
                فـــخــر الصنـــاعـــــة <br />
                الــســـــــــــعوديــــة
              </h1>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 z-10 flex flex-col items-center">
          <p className="relative top-8 w-10 min-w-max -rotate-90">
            {trans("scroll")}
          </p>

          <ScrollAnimationIcon />
        </div>
      </div>
    </div>
  );
}
